/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgIcon = forwardRef((props, ref) => {
  const {
    children,
    rounded,
    backgroundColor,
    color = 'current',
    size = 'regular',
    ...other
  } = props;

  const classes = classNames('sui-inline-block sui-align-baseline', {
    'sui-fill-current': color === 'current',
    'sui-fill-inherit': color === 'inherit',
    'sui-fill-primary': color === 'primary',
    'sui-fill-inverse': color === 'inverse',
    'sui-fill-subtle': color === 'subtle',
    'sui-fill-medium': color === 'medium',
    'sui-fill-success': color === 'success',
    'sui-fill-warning': color === 'warning',
    'sui-fill-danger': color === 'danger',
    'sui-fill-info': color === 'info',
    'sui-bg-primary': backgroundColor === 'primary',
    'sui-bg-inverse': backgroundColor === 'inverse',
    'sui-bg-inactive': backgroundColor === 'inactive',
    'sui-rounded-full': rounded,
    'sui-w-[1em] sui-h-[1em]': size === 'inherit',
    'sui-w-4 sui-h-4': size === 'small', // 16px
    'sui-w-6 sui-h-6': size === 'regular', // 24px
    'sui-w-8 sui-h-8': size === 'large', // 32px
  });

  return (
    <svg
      className={classes}
      ref={ref}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      {...other}
    >
      {children}
    </svg>
  );
});

SvgIcon.displayName = 'SvgIcon';

SvgIcon.propTypes = {
  /**
   * @ignore
   */
  rounded: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'inverse', 'inactive', 'subtle', 'success', 'danger', 'medium', 'warning', 'info', 'current', 'inherit']),
  backgroundColor: PropTypes.oneOf(['primary', 'inactive', 'inverse']),
  size: PropTypes.oneOf(['small', 'regular', 'large', 'inherit'])
};

SvgIcon.defaultProps = {
};

export { SvgIcon };